export const locale = {
    lang: 'tr',
    data: {
      'CIERRE': {
         'LABEL1': 'Anket devam ediyor',
         'LABEL2': 'İlerleme görmek',
         'LABEL3': 'Anket Tamamlandı',
         'LABEL4': 'Sonuç görmek',
         'BTN_CIERRE': 'Şimdi kapat',
         'ALERT':{
           'MESSAGE': 'Beklenen anketi kapatmak için onaylıyor musunuz?',
           'BTN_CONFIRM': 'Evet',
           'BTN_CANCEL': 'Hayır'
         },
         'LINK': 'Anketin şu anki ilerlemesini görmek için sonraki bağlantıya gidin',
         'ACTIONS':{
           'TITULO': 'Eylemler',
           'WANNADO': 'Ne yapmak istiyorsun?'
         },
         'COMPLETO':{
           'TAG': 'Anket başarıyla tamamlandı',
           'CARDTIT': 'Sonuç sorgusu',
           'LINK': 'Ankette elde edilen sonuçları görmek için bir sonraki bağlantıya gidin'
         }
      },

      'CERTIFICAR': {
        'IDIOMAS': {
          'ELEGIR': 'Seçiniz',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'MENSAJES':{
            'ADDLANG': 'Dil eklendi',
            'NOADITIONAL': 'Ek dil seçimi yapılmamıştır',
            'ERRORADD': 'Dil seçimi yapılırken bir hata oluştu ',
            'LANGDEL': 'Bu dil silindi',
            'NOADITIONALDEL': 'Seçim ek dil uygulanmadan iptal edildi',
            'ERRORDEL': 'Dil silinirken bir hata oluştu ',
            'MAINPICKED': 'Bu anket için ana dil seçilmiştir..<br><br>Değiştirmek için, seçilmiş olan dili kaldırdıktan sonra yenisini ekleyin.'
          },
          'CARD1': {
            'TITULO': 'Ana dil',
            'ACCION': {
              'PRE': 'Ana dili seçmediniz',
              'POST': 'Seçmiş olduğunuz dil:'
            },
            'MODAL': {
              'TITULO': 'Ana dili seçin',
              'ACCION': 'Anketin ana dili?',
              'PLACELISTA': 'Dili seçin',
              'BOTONES': {
                'BACK': 'Geri',
                'OK': 'Hazır'
              }
            }
          },
          'CARD2': {
            'TITULO': 'Ek diller',
            'ACCION': {
              'PRE': 'Herhangi bir ek dil seçmediniz',
              'SINADIC': 'Anket ek dil içermeyecek',
              'POST': 'Seçmiş olduğunuz diller:'
            },
            'MODAL': {
              'TITULO': 'Ek dilleri seçiniz',
              'ACCION': 'Anketinize hangi ek dilleri dahil etmek istiyorsunuz?',
              'BOTONES': {
                'BACK': 'Geri',
                'OK': 'Hazır'
              }
            }
          }
        },
        'DEMOGRAFICOS': {
          // 'TAB1': 'Demograficos',
          // 'TAB2': 'Traducción',
          // 'TAB3': 'Previsualización',
          // 'COMPLETAR_PASO': 'Completar paso',
          // 'PASO_COMPLETADO': 'Paso completado',
          // 'SELECT': 'Seleccione una opción',
          // 'BTN_DEMOGRAFICOS': 'Aceptar',
          // 'OPTION_SURVEY': 'Encuesta',
          // 'OPTION_EXCEL': 'Excel',
          // 'CONFIGURE_QUESTION': 'Click aquí para configurar la pregunta',
          // 'QUESTION': 'Pregunta',
          // 'OPCIONES_RESPUESTA': 'Opciones de respuesta',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          }
        },
        'FORALL': {
          // 'SELECCIONE': 'Seleccione un Idioma para hacer una vista previa',
          // 'IDIOMAS_NOT_SELECTED': 'No se seleccionaron idiomas adicionales.',
          // 'PLACEHOLDER': 'Idioma',
          // 'DESC_TRANSLATE': 'Ingrese la traducción de la descripción',
          // 'PRACTICE_TRANSLATE': 'Ingrese la traducción de la práctica',
          // 'IDIOMAS': {
          //     'Native': 'Nativo',
          //     'es': 'Español',
          //     'zh1': 'Chino Tradicional',
          //     'zh2': 'Chino Simplificado',
          //     'pt': 'Portugués',
          //     'en': 'Inglés'
          //   },
          // 'RESPUESTAS': {
          //     'Native': 'Nativo',
          //     'es':{'si': 'SÍ',
          //           'no':'NO',
          //           'casifalso':'Casi siempre es falso',
          //           'false': 'Frecuentemente es falso',
          //           'avecesfalse': 'A veces es falso / A veces es verdad',
          //           'casiverdad': 'Frecuentemente es verdad',
          //           'verdad': 'Casi siempre es verdad'},
          //     'zh1':{'si': '对','no':'没有',
          //           'casifalso':'卡西尔·辛普森·法斯特',
          //           'false': '基金会',
          //           'avecesfalse': '途径/途径',
          //           'casiverdad': '纪念馆',
          //           'verdad': '普通绿卡'},
          //     'zh2':{'si': '对','no':'没有',
          //           'casifalso':'卡西尔·辛普森·法斯特',
          //           'false': '基金会',
          //           'avecesfalse': '途径/途径',
          //           'casiverdad': '纪念馆',
          //           'verdad': '普通绿卡'},
          //     'pt':{'si': 'SI','no':'não',
          //           'casifalso':'Casi siempre es falso',
          //           'false': 'Freqüentemente é falso',
          //           'avecesfalse': 'A veces es falso / A veces es verdad',
          //           'casiverdad': 'Freqüentemente es verdad',
          //           'verdad': 'Casi siempre es verdad'},
          //     'en':{'si': 'YES','no':'NO',
          //           'casifalso':'It is almost always false',
          //           'false': 'It is often false',
          //           'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
          //           'casiverdad': 'It is often true',
          //           'verdad': 'It is almost always true'}
          //   },
            'STATUS': {
              'PEND': 'İşlemi tamamlayınız',
              'DONE': 'İşlem tamamlandı'
            },
            'TABLA': {
              'TITULOS': {
                'DEFAULT': 'Ana dil',
                'TRADUCCION': 'Çeviriler',
                'PREVIEW': 'Ön izleme'
              },
              'ENCABEZADOS': {
                'PRACT': 'Uygulama',
                'DESCR': 'Tanım',
                'STT1': 'İfade 1',
                'STT2': 'İfade 2',
                'LANG': 'Dil'
              },
              'INPUTS': {
                'PRACT': 'For All uygulaması için kullanılacak metni girin',
                'DESCR': 'For All uygulamasıyla ilgili tanımı girin'
              }
            }
        },
        'ADICIONALES': {
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'TABS': {
            'QUESTIONS': 'Ek sorular',
            'TRANSLATE': 'Çeviriler',
            'PREVIEW': 'Ön izleme'
          },
          'PREGUNTAS':{
            'STATUS': {
              'SIN': 'Herhangi bir ek soru oluşturulmadı',
              'CON': 'Oluşturulmuş olan sorular:',
              // 'NOADICIONALES': 'Se eligió la opción sin preguntas adicionales',
              // 'CANCELNOADIC': 'Se canceló la opción sin preguntas adicionales',
              // 'ERROR': 'Ocurrió un error al realizar la operación'
            },
            'ACCIONES': {
              'ADD': 'Soru oluştur',
              'SIN': 'Bu anket ek sorular içermeyecek'
            },
            'WIZARD': {
              'NEW': 'Yeni soru',
              'TIPOTITU': 'Ek soru oluşturmak için burayı tıklayın',
              'TIPO': {
                'OPEN': 'Açık soru',
                'UNI': 'Tek seçimli soru',
                'MULT': 'Çoklu seçimli soru'
              },
              'FORM': {
                'TIPO': 'Soru tipi',
                'TOOLTIP': {
                  'REMOVE': 'Bu soruyu sil'
                },
                // 'MENSAJES': {
                //   'BORRAR': '¿Desea borrar esta pregunta adicional?',
                //   'PREG_OK': 'La pregunta se almacenó correctamente',
                //   'PREG_ERR': 'Ocurrió un error al almacenar la pregunta',
                //   'PREG_MOD_OK': 'La pregunta se modificó correctamente',
                //   'PREG_MOD_ERR': 'Ocurrió un error al modificar la pregunta',
                //   'OPC_OK': 'La opción de respuesta se almacenó correctamente',
                //   'OPC_ERR': 'Ocurrió un error al almacenar la opción de respuesta',
                //   'OPC_MOD_OK': 'La opción de respuesta se modificó correctamente',
                //   'OPC_MOD_ERR': 'Ocurrió un error al modificar la opción de respuesta',
                //   'PREG_DEL_OK': 'La pregunta se eliminó correctamente',
                //   'PREG_DEL_ERR': 'Ocurrió un error al eliminar la pregunta',
                //   'OPC_DEL_OK': 'La opción de respuesta fue eliminada correctamente',
                //   'OPC_DEL_ERR': 'Ocurrió un error al eliminar la opción de respuesta'
                // },
                // 'BOTONES':{
                //   'SI': 'Si',
                //   'NO': 'No'
                // }
              },
              'ABIERTA': {
                'TITULO': 'Yeni açık soru',
                'ACCION': 'Soru metnini girin',
                'ERROR': 'Soru metnini girmediniz'
              },
              'MULTI':{
                'TITULOSING': 'Yeni tek seçimli soru',
                'TITULOMULT': 'Yeni çoklu seçimli soru',
                'ACCION': 'Soruyu girin',
                'ERROR': 'Soruyu girmediniz',
                // 'MENSAJES': {
                //   'BORRAR': '¿Desea borrar esta opción de respuesta?',
                //   'SINPREG': 'No puede introducir opciones hasta que introduzca el texto de la pregunta',
                //   'SINANTE': 'No puede introducir el texto de esta opción hasta que introduzca el texto de la opción anterior'
                // },
                'OPCIONES': {
                  'TITU': 'Cevap seçenekleri',
                  'INPUT': {
                    'TITU': 'Cevap seçeneği',
                    'ERROR': 'Cevap seçeneğini girmediniz'
                  }
                },
                'TOOLTIP': {
                  'ADD': 'Seçeneği ekleyin',
                  'MOVE': 'Seçeneği taşı',
                  'REMOVE': 'Bu seçeneği kaldır'
                }
              }
            }
          },
          'TRADUCCIONES': {
            // 'TITULO': 'Seleccione un idioma para introducir los textos de traducción',
            // 'TITULOALTERNO': 'No seleccionó idiomas adicionales en la sección "Idiomas"',
            'NOTYET': 'Çeviri henüz tamamlanmadı.',
            'MAIN': 'Ana dil',
            'INPUT': {
              'NEW': 'Soru çevirisini girin',
              'ERROR': 'Soru çevirisini girmediniz!',
              'NEWOPC': 'Cevap seçeneği çevirisini girin',
              'ERROROPC': 'Çeviri metni girilmedi!'
            },
            // 'MENSAJES': {
            //   'PREG_OK': 'El texto de traducción se almacenó correctamente',
            //   'PREG_ERR': 'Ocurrió un error al almacenar el texto de traducción',
            //   'PREG_MOD_OK': 'El texto de traducción se actualizó correctamente',
            //   'PREG_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción',
            //   'OPC_NOPREG': 'No se puede almacenar el texto de traducción de la opción de respuesta sin que introduzca primero el texto de la pregunta',
            //   'OPC_OK': 'El texto de traducción se almacenó correctamente',
            //   'OPC_ERR': 'Ocurrió un error al almacenar el texto de traducción',
            //   'OPC_MOD_OK': 'El texto de traducción se actualizó correctamente',
            //   'OPC_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción'
            // },
            'COMPLETE': 'Çeviri tamamlandı '
          },
          // 'PREVIEW': {
          //   'TITULO': 'Seleccione un idioma para mostrar las traducciones de las preguntas adicionales',
          //   'SINPREV': 'No existen textos traducidos para el idioma seleccionado',
          //   'LOADING': 'Cargando datos',
          //   'INPUT': {
          //     'RESPABIERTA': 'Escriba su respuesta',
          //     'ERRORABIERTA': '¡No ha escrito su respuesta!',
          //     'ELIGELANG': 'Elija un idioma'
          //   }
          // }
        },
        'COLABORADORES': {
          'SHEET':{
            'NUMBER':'Sayfa Adı'
          },
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı',
            'LOCK': 'Geçidi yeniden aç',
          },
          // 'STATUSBAR': {
          //   'NOBD': 'No ha cargado la base de datos de colaboradores',
          //   'PROCES': 'La base de datos de colaboradores aún no ha sido almacenada',
          //   'ERROR': 'Se encontraron errores en el archivo',
          //   'OK': 'La base de datos de colaboradores está almacenada correctamente'
          // },
          // 'CARD_BD': {
          //   'TITULO': 'Información',
          //   'NUMCOLABS': 'Número de colaboradores',
          //     'NUMCENTER': 'Number of work center',
          //   'FECHA': 'Fecha de carga',
          //   'ACCIONES': 'Acciones',
          //   'WANNADO': '¿Qué desea realizar?',
          //   'BOTONES': {
          //     'DESCARGA': 'Descargar la base de datos',
          //     'ELIMINA': 'Eliminar la base de datos'
          //   }
          // },
          // 'CARD_NOBD': {
          //   'TITULO': 'Siga estos pasos para cargar la información de sus colaboradores a CulturalGO',
          //   'PASOS': {
          //     '1': 'Descargue la plantilla de base de datos de colaboradores',
          //     '2': 'Llene la plantilla con la información de sus colaboradores, con base en las columnas proporcionadas',
          //     '3': 'Cargue el archivo con la información de sus colaboradores'
          //   },
          //   'TOOLTIP': 'Este archivo cuenta con macros de validación de datos'
          // },
          // 'CARD_NOERR': {
          //   'TITULO': 'Información',
          //   'NUMCOLABS': 'Número de colaboradores en el archivo',
          //  'NUMCT': 'Number of work cnter in the loaded file',
          //   'FILENAME': 'Nombre del archivo',
          //   'GUARDAR': '¿Desea almacenar esta información?',
          //   'BOTONES': {
          //     'SI': 'Si',
          //     'NO': 'No'
          //   }
          // },
          // 'CARD_ERRFND': {
          //   'TITULO': 'Información',
          //   'ROWS_OK': 'Número de filas correctas',
          //   'ROWS_NOTOK': 'Número de filas con errores',
          //   'MOREINFO': '* Mas abajo se muestra a detalle la lista de errores',
          //   'FILENAME': 'Nombre del archivo',
          //   'GUARDAR': 'La información cargada no puede ser almacenada',
          //   'DELETE': 'Borrar archivo'
          // },
          'CARD_ERRLIST': {
          //   'TITULO': {
          //     '1': 'Filas con errores: ',
          //     '2': 'Errores totales encontrados: '
          //   },
          //   'INFO': {
          //     'ROW': 'Fila ',
          //     'ERRNUM': 'Número de errores: ',
          //     'SHOW': 'Haga clic aquí para ver los errores de esta fila'
          //   },
          //   'DETALLE': {
          //     'TIPO': 'Tipo de error',
          //     'DESCR': 'Descripción',
          //     'COLUMNA': 'Columna',
          //     'DATO': 'Dato erróneo'
          //   },
            'ERRORES': {
          //     'alfabetica': 'Invalidez alfabética',
          //     'alfanumerica': 'Invalidez alfanumérica',
          //     'numerica': 'Invalidez numérica',
          //     'email': 'Invalidez de correo electrónico',
          //     'vacio': 'Celda vacía',
          //     'columna': 'Columna desconocida',
                'CT': 'İş merkezi bulunamadı'
            },
            'DESCRIPCION': {
          //     'alfabetica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z) y los siguientes caracteres especiales: ( ) . , : - ',
          //     'alfanumerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z), numéricos (0 - 9) y los siguientes caracteres especiales: ( ) . , : - ',
          //     'numerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres numéricos (0 - 9)',
          //     'email': 'La información no cuenta con la sintáxis correcta ( correo@dominio.com )',
          //     'vacio': 'La celda carece de información. Esta columna es obligatoria.',
          //     'columna': 'La columna no pertenece a la plantilla proporcionada por CulturalGO',
                'CT': 'Bu satırdaki belirtilen iş merkezi, mevcut iş merkezi listesinde bulunamadı.'
            }
          },
          // 'CARD_LOAD': {
          //   'CARGA': {
          //     'TITULO': 'Cargando',
          //     'INFO': 'Analizando la información del archivo, espere un momento'
          //   },
          //   'GUARDA': {
          //     'TITULO': 'Guardando',
          //     'INFO': 'Almacenando la información en el sistema, permanezca en esta pantalla hasta que el proceso finalice'
          //   },
          // },
          // 'MENSAJES': {
          //   'GUARDA_1': '¿Confirma almacenar la información de ',
          //   'GUARDA_2': ' colaboradores?',
          //   'GUARDADO': 'La base de datos de colaboradores se almacenó correctamente',
          //   'GUA_ERR': 'Ocurrió un error al almacenar la información. Intente nuevamente mas tarde',
          //   'DELETE_1': '¿Confirma eliminar la información de ',
          //   'DELETE_2': ' colaboradores?',
          //   'DEL_OK_1': 'se eliminaron correctamente ',
          //   'DEL_OK_2': ' colaboradores',
          //   'DEL_ERR': 'Ocurrió un error al eliminar la base de datos de colaboradores. Intente nuevamente mas tarde',
          //   'DELFILE': 'La base de datos cargada se removió correctamente',
          //   'EXCEL': 'Generando archivo de excel, por favor espere un momento',
          //   'EXTMAL': 'El archivo seleccionado no tiene la extensión correcta. Sólo se permite la carga del archivo proporcionado por CulturalGO',
          //   'NOROWS': 'El archivo seleccionado no cuenta con ningún registro',
          //   'VACIO': 'El archivo seleccionado está vacío, o la información no se encuentra en la primera hoja',
          //   'BOTONES': {
          //     'SI': 'Si',
          //     'NO': 'No'
          //   }
          // },
          // 'EXCELINFO': {
          //   'HOJA': 'Datos de colaboradores',
          //   'TITULO': 'Base de datos de colaboradores',
          //   'AUTOR': 'CulturalGO',
          //   'ASUNTO': 'Descargado de la plataforma'
          // },
          'UPLOAD': 'Katılımcı veri tabanını araştır',
          'REMOVE': 'Veri yükünü sil',
          'SEND': 'Veri tabanına gönder',
          'PROCESO': {
            'STP1': 'Katılımcı veri tabanı analiz ediliyor',
            'STP2': 'Katılımcı verisi kaydediliyor'
          }
        }
      }
    }
};
